import { render, staticRenderFns } from "./SpineExerciseVideoPage.vue?vue&type=template&id=3a7ab25a&scoped=true"
import script from "./SpineExerciseVideoPage.vue?vue&type=script&lang=js"
export * from "./SpineExerciseVideoPage.vue?vue&type=script&lang=js"
import style0 from "./SpineExerciseVideoPage.vue?vue&type=style&index=0&id=3a7ab25a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7ab25a",
  null
  
)

export default component.exports